module.exports = __webpack_public_path__ + "img/16.ddcb5d60.png";